module.exports = "https://static.wmbcdn.com/uniweb/images/34d63c7fc44aed877e080520a4215ffd.svg";